import { render, staticRenderFns } from "./Contextmenu.vue?vue&type=template&id=b690976e&"
import script from "./Contextmenu.vue?vue&type=script&lang=ts&"
export * from "./Contextmenu.vue?vue&type=script&lang=ts&"
import style0 from "./Contextmenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports